import bookingStepOne from './step-one';
import bookingStepTwo from './step-two';
import bookingStepFinal from './step-final';

declare let booking_object: any;

interface BookingStep{

    sendData(nextButton: string, elForm: string): Promise<boolean>;
    
}

export default class BookingActionsSteps{
    
    protected elForm: string;
    protected prevButton: string;
    protected nextButton: string;
    protected callRestApi: string;
    protected output: boolean;
    private steps: Record<number, BookingStep>;

    /**
     * Constructor initializes form elements and API settings.
     * @param elForm The form selector.
     * @param prevButton The previous step button selector.
     * @param nextButton The next step button selector.
     */
    constructor(elForm: string, prevButton: string, nextButton: string){
        
        this.elForm = elForm;
        this.prevButton = prevButton;
        this.nextButton = nextButton;
        this.callRestApi = booking_object.rest_urls.step_one;
        this.output = false;

        // Initialize steps dynamically
        this.steps = {
            0: new bookingStepOne(),
            1: new bookingStepTwo(),
            2: new bookingStepFinal('#btn-payment', '#booking-payment-element')
        };

    }

    /**
     * Executes the corresponding action for the specified step.
     * @param step The step number.
     * @returns A boolean result of the action.
     */
    async getAction(step: number): Promise<boolean>{

        if(this.steps[step]){
            
            this.output = await this.steps[step].sendData(this.nextButton, this.elForm);

        }else{

            this.output = false;

        }

        return this.output;

    }

    /**
     * Dynamically adds a new step to the booking flow.
     * @param step The step number.
     * @param instance An instance of a class implementing BookingStep.
     */
    addStep(step: number, instance: BookingStep): void{

        this.steps[step] = instance;

    }

}